import script from "./Documents.vue?vue&type=script&lang=ts&setup=true"
export * from "./Documents.vue?vue&type=script&lang=ts&setup=true"

import "./Documents.vue?vue&type=style&index=0&id=fe2c480e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fe2c480e"]])

export default __exports__